module.exports = __webpack_public_path__ + "img/retro_main_m.f0b6e661.gif";